module.exports = __webpack_public_path__ + "img/474.c38e20ba.jpg";